import React from 'react';
import { Form, Switch } from 'antd';
import { FORM_KEYS } from '@modules/insights/valueDriverManager/content/config/form.keys';
// import { VALUEDRIVER_FORM_CATE } from '@model';

function ValueDriverRadioSetting({ isSystemSetting, formChange = () => {} }) {
  return (
    <div className="radio-setting-wrapper">
      {!isSystemSetting && (
        <div className="display-value-bridge-switch-wrapper">
          <span>Display EBIT & Diligence Earnings on Value Bridge</span>
          <Form.Item
            name={FORM_KEYS.displayEbitAndDiligence.key}
            initialValue={true}
            valuePropName="checked"
          >
            <Switch className="switch" size="small" />
          </Form.Item>
        </div>
      )}
      <div className="display-value-bridge-switch-wrapper">
        <span>Display $ figures on Value Bridge</span>
        <Form.Item
          name={FORM_KEYS.DisplayFigures.key}
          initialValue={true}
          valuePropName="checked"
        >
          <Switch className="switch" size="small" onChange={formChange} />
        </Form.Item>
      </div>
    </div>
  );
}

export default ValueDriverRadioSetting;
